import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const CalendarDesignSettings = {
  // dimension
  'calendar-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  // spacing
  'calendar-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'calendar-design-padding': {
    phone: getDefaultMargin([0]),
    'phone-landscape': getDefaultMargin([0]),
    tablet: getDefaultMargin([0]),
    'tablet-landscape': getDefaultMargin([0]),
    desktop: getDefaultMargin([0]),
    tv: getDefaultMargin([0]),
  },
  // alignment
  'calendar-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  // typography
  'calendar-design-typography': {
    'calendar-design-title-typography': {
      phone: getDefaultTypography('Title Small'),
      'phone-landscape': getDefaultTypography('Title Small'),
      tablet: getDefaultTypography('Title Small'),
      'tablet-landscape': getDefaultTypography('Title Small'),
      desktop: getDefaultTypography('Title Small'),
      tv: getDefaultTypography('Title Small'),
    },
    'calendar-design-content-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
  // corner radius
  'calendar-design-corner-radius': {
    phone: 'none',
    'phone-landscape': 'none',
    tablet: 'none',
    'tablet-landscape': 'none',
    desktop: 'none',
    tv: 'none',
  },
}
